import { DEFAULT_KEY } from '../constants';
import { generate32ByteKey, generate12ByteNonce, stringToUint8Array } from '../utils/stringUtils';
import { Chacha20 } from 'ts-chacha20';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function decrypt(encryptedMessage, key, nonce) {
  key = key.length > 0 ? key : DEFAULT_KEY;
  key = generate32ByteKey(key);
  nonce = generate12ByteNonce(nonce ?? "");
  const keyBuffer = stringToUint8Array(key);
  const nonceBuffer = stringToUint8Array(nonce);
  const chacha20 = new Chacha20(keyBuffer, nonceBuffer);
  const encryptedBuffer = new Uint8Array(Buffer.from(encryptedMessage, "hex"));
  const decrypted = chacha20.decrypt(encryptedBuffer);
  return Buffer.from(decrypted).toString("utf-8");
}
__name(decrypt, "decrypt");

export { decrypt };
